var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"goBackBtn"}},[_c('div',{staticClass:"btn-return",on:{"click":_vm.handleReturn}},[_c('img',{attrs:{"src":require('@/assets/images/wx_return.png'),"alt":""}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07bbb7d3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subComponents/MyBtnReturn.vue
// module id = AlWE
// module chunks = 0